import { fetchFromOldApi } from '~/services/Http';

export type Audience = {
  unitAudience: string[];
  roleAudience: string[];
  countryAudience: string[];
};

export type DocumentType = {
  fDocumentId: number;
  fDocumentName: string;
  fDocumentDocType: string;
  fDocumentDescription: string;
  fDocumentAttachment: File | undefined;
  fDocumentApprovalStatus?: string;
  fDocumentCreated: string;
  fDocumentModified: string;
  fDocumentExpirationDate?: string;
  fDocumentEmpId?: number;
  fDocumentOwnerId?: number;
  fDocumentOwnerType?: string;
  fDocumentDocReadOnly?: boolean;
  fDocumentSize?: number;
  fDocumentSha1Hash?: string;
  fDocumentAudience?: Audience;
};

export const getEmployeeDocuments = (
  iEmpId: string,
): Promise<DocumentType[]> => {
  return fetchFromOldApi('/json/employee/' + iEmpId + '/file').then((r) =>
    r.json(),
  );
};

export const getCompanyDocuments = (): Promise<DocumentType[]> => {
  return fetchFromOldApi('/json/company/file').then((r) => r.json());
};

export const putDocumentData = async (
  json: FormData | Object,
  iEmpId: number,
  iDocId: number,
) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/file/' + iDocId, {
    method: 'PUT',
    body: json as FormData,
  }).then((r) => r.json());
};

export const postDocumentData = async (
  json: FormData | Object,
  iEmpId: number,
  type: string,
) => {
  return await fetchFromOldApi(`/${type}/employee/${iEmpId}/file`, {
    method: 'POST',
    body: json as FormData,
  }).then((r) => r.json());
};

export const deleteDocument = async (iEmpId: number, documentId: number) => {
  return await fetchFromOldApi(`/json/employee/${iEmpId}/file/${documentId}`, {
    method: 'DELETE',
  }).then((r) => r.json());
};
